export default __webpack_public_path__ + "static/media/illustration-algostudy-n-w@2x.c4f71a8c.webp";